export const algoliaIndex = "requestly_dev_products"
